import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconHtmlItalic = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 8 12",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "nonzero",
		d: "M5.31666 10.28571H4.3209L6.1475 1.7143h1.19804c.2252 0 .41886-.14526.46198-.34653l.18362-.85714C8.04783.246 7.82528 0 7.52917 0H2.83019c-.2252 0-.41886.14526-.46197.34653l-.18363.85714c-.05669.26462.16586.51062.46198.51062h.99567L1.81569 10.2857H.65455c-.2252 0-.41884.14523-.46198.34648l-.18371.85714c-.05669.26464.16586.51067.462.51067h4.66209c.22519 0 .41884-.14523.46197-.34647l.18372-.85715c.05668-.26464-.16586-.51067-.46198-.51067z"
	})
});
export default SvgIconHtmlItalic;
